export function getFileItemsFromResponse(data) {
  return { count: data.count, items: data.objects, parent: data.parent }
}
